import React from "react"

import { Link, graphql, useStaticQuery } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./sidebar-item.module.scss"
import storyType from "../../../helpers/story-type"
import Heading from "../../atoms/heading"
import Tag from "../../atoms/tag"

const SidebarItem = ({ item, sidebarContainer }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  const title = () =>
    item.detailed_title ||
    item.faqGlossarySport?.name ||
    item.sport?.name ||
    item.title ||
    allSanityDictionary.nodes.find(
      (dictionaryItem) => dictionaryItem.key.current === "general"
    )?.value

  const label =
    item.web_article_type || item._type || item.type
      ? storyType({
          item,
          dictionary: allSanityDictionary.nodes,
          type: item.web_article_type || item._type || item.type,
        })
      : item.label

  const url = () => {
    if (item.type === "faq" || item.type === "glossary")
      return `/${item.type}/${
        item.sport?.slug.current ||
        item.faqGlossarySport?.slug.current ||
        "general"
      }`
    if (item.web_article_type)
      return `/${item.web_article_type}/${item.slug.current}`
    if (item.slug) return `/${item.type}/${item.slug.current}`
    return item.url
  }

  const image = () => {
    if (item.featured_image?.image) return item.featured_image.image
    if (item.featured_image) return item.featured_image
    return item.image
  }

  if (!item) return ""

  const contents = (
    <>
      <div className={item.type === "podcast" ? styles.imageWrap__podcast : ""}>
        {image()?.asset ? (
          <Image
            className={styles.image}
            {...image()}
            width={350}
            alt={title()}
          />
        ) : (
          <StaticImage
            className={styles.image}
            src="../../../images/scenes/star.jpg"
            aspectRatio={1 / 1}
            alt=""
          />
        )}
      </div>
      {label ? (
        <div className={styles.storyType}>
          <Tag color="white">{label}</Tag>
        </div>
      ) : (
        ""
      )}
      <Heading level={4}>{title()}</Heading>
    </>
  )

  return url() ? (
    <Link
      to={url()}
      className={`${styles.item} ${styles.item__link} ${
        !sidebarContainer ? styles.item__auto : ""
      }`}
    >
      {contents}
    </Link>
  ) : (
    <div
      className={`${styles.item} ${!sidebarContainer ? styles.item__auto : ""}`}
    >
      {contents}
    </div>
  )
}

export default SidebarItem

SidebarItem.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  sidebarContainer: PropTypes.bool,
}

SidebarItem.defaultProps = {
  sidebarContainer: false,
}
